import * as React from "react"

export const FlagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 10.584v5.666a.53.53 0 0 1-.155.386.52.52 0 0 1-.383.156.53.53 0 0 1-.387-.156.52.52 0 0 1-.158-.386V4.087q0-.285.192-.477a.65.65 0 0 1 .478-.193h5.052q.251 0 .433.138a.6.6 0 0 1 .23.36l.361 1.502h3.75a.65.65 0 0 1 .478.192.64.64 0 0 1 .192.475v5.833a.64.64 0 0 1-.192.475.65.65 0 0 1-.478.192h-3.057a.7.7 0 0 1-.423-.139.6.6 0 0 1-.234-.36l-.362-1.501zm6.667.916H14.5v-5h-3.648a.7.7 0 0 1-.422-.138.6.6 0 0 1-.235-.36L9.833 4.5H5.5v5h5.648a.7.7 0 0 1 .422.138.6.6 0 0 1 .235.36z"
    ></path>
  </svg>
)
